<!--
 * @Description:
 * @Author: 王赵坤
 * @Date: 2022-10-27 11:06:59
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-01-10 17:07:18
 * @FilePath: \VUE3\src\pages\jiaowu\views\pkgl\paikerenwu\xiaolibanjikebiao.vue
-->

<template>
  <el-table :data="tableData" v-loading="loading" :span-method="dSpanCellMerge" border style="width: 100%;">
    <el-table-column prop="id" label="时段" align="center" width="46px">
      <template #default="scope">
        <p style="writing-mode: tb-rl;" v-if="scope.row.sd==1">上 午</p>
        <p style="writing-mode: tb-rl;" v-if="scope.row.sd==2">下 午</p>
        <p style="writing-mode: tb-rl;" v-if="scope.row.sd==3">晚 上</p>
      </template>
    </el-table-column>
    <el-table-column prop="amount1" label="节次" align="center" width="80px">
      <template #default="scope">
        <span>第{{scope.row.xq1.jc}}节</span>
      </template>
    </el-table-column>
    <el-table-column prop="kssj" label="上课时间" align="center" width="90px">
      <template #default="scope">
        <span>{{scope.row.kssj}}</span>-<span>{{scope.row.jssj}}</span>
      </template>
    </el-table-column>
    <el-table-column align="center">
      <template v-slot:header>
            <div>星期一</div>
            <div>{{jtsjfirm.sj1}}</div>
    </template>
      <template #default="scope">
        <div v-for="elem in scope.row.xq1.kclist" :key="elem.id" @click="chuanshujv(elem,jtsjfirm.sj1,1)"
          class="divspanlv">
          <span v-if="elem.sklx==2">{{elem.kcmc}}(拆)</span>
          <span v-if="elem.sklx==1">{{elem.kcmc}}(合)</span>
          <span v-if="elem.sklx==0">{{elem.kcmc}}</span>
          <div>
            <span v-show="elem.kclb==1">理论</span>
            <span v-show="elem.kclb==2">实践</span>
          </div>
          <span>{{elem.jsxms}}</span>
        </div>
      </template>
    </el-table-column>
    <el-table-column align="center">
      <template v-slot:header>
            <div>星期二</div>
            <div>{{jtsjfirm.sj2}}</div>
    </template>
      <template #default="scope">
        <div v-for="elem in scope.row.xq2.kclist" :key="elem.id" @click="chuanshujv(elem,jtsjfirm.sj2,1)"
          class="divspanlv">
          <span v-if="elem.sklx==2">{{elem.kcmc}}(拆)</span>
          <span v-if="elem.sklx==1">{{elem.kcmc}}(合)</span>
          <span v-if="elem.sklx==0">{{elem.kcmc}}</span>
          <div>
            <span v-show="elem.kclb==1">理论</span>
            <span v-show="elem.kclb==2">实践</span>
          </div>
          <span>{{elem.jsxms}}</span>
        </div>
      </template>
    </el-table-column>
    <el-table-column align="center">
      <template v-slot:header>
            <div>星期三</div>
            <div>{{jtsjfirm.sj3}}</div>
    </template>
      <template #default="scope">
        <div v-for="elem in scope.row.xq3.kclist" :key="elem.id" @click="chuanshujv(elem,jtsjfirm.sj3,1)"
          class="divspanlv">
          <span v-if="elem.sklx==2">{{elem.kcmc}}(拆)</span>
          <span v-if="elem.sklx==1">{{elem.kcmc}}(合)</span>
          <span v-if="elem.sklx==0">{{elem.kcmc}}</span>
          <div>
            <span v-show="elem.kclb==1">理论</span>
            <span v-show="elem.kclb==2">实践</span>
          </div>
          <span>{{elem.jsxms}}</span>
        </div>
      </template>
    </el-table-column>
    <el-table-column align="center">
      <template v-slot:header>
            <div>星期四</div>
            <div>{{jtsjfirm.sj4}}</div>
      </template>
      <template #default="scope">
        <div v-for="elem in scope.row.xq4.kclist" :key="elem.id" @click="chuanshujv(elem,jtsjfirm.sj4,1)"
          class="divspanlv">
          <span v-if="elem.sklx==2">{{elem.kcmc}}(拆)</span>
          <span v-if="elem.sklx==1">{{elem.kcmc}}(合)</span>
          <span v-if="elem.sklx==0">{{elem.kcmc}}</span>
          <div>
            <span v-show="elem.kclb==1">理论</span>
            <span v-show="elem.kclb==2">实践</span>
          </div>
          <span>{{elem.jsxms}}</span>
        </div>
      </template>
    </el-table-column>
    <el-table-column align="center">
      <template v-slot:header>
            <div>星期五</div>
            <div>{{jtsjfirm.sj5}}</div>
      </template>
      <template #default="scope">
        <div v-for="elem in scope.row.xq5.kclist" :key="elem.id" @click="chuanshujv(elem,jtsjfirm.sj5,1)"
          class="divspanlv">
          <span v-if="elem.sklx==2">{{elem.kcmc}}(拆)</span>
          <span v-if="elem.sklx==1">{{elem.kcmc}}(合)</span>
          <span v-if="elem.sklx==0">{{elem.kcmc}}</span>
          <div>
            <span v-show="elem.kclb==1">理论</span>
            <span v-show="elem.kclb==2">实践</span>
          </div>
          <span>{{elem.jsxms}}</span>
        </div>
      </template>
    </el-table-column>
    <el-table-column align="center">
      <template v-slot:header>
            <div>星期六</div>
            <div>{{jtsjfirm.sj6}}</div>
      </template>
      <template #default="scope">
        <div v-for="elem in scope.row.xq6.kclist" :key="elem.id" @click="chuanshujv(elem,jtsjfirm.sj6,1)"
          class="divspanlv">
          <span v-if="elem.sklx==2">{{elem.kcmc}}(拆)</span>
          <span v-if="elem.sklx==1">{{elem.kcmc}}(合)</span>
          <span v-if="elem.sklx==0">{{elem.kcmc}}</span>
          <div>
            <span v-show="elem.kclb==1">理论</span>
            <span v-show="elem.kclb==2">实践</span>
          </div>
          <span>{{elem.jsxms}}</span>
        </div>
      </template>
    </el-table-column>
    <el-table-column align="center">
      <template v-slot:header>
            <div>星期日</div>
            <div>{{jtsjfirm.sj7}}</div>
      </template>
      <template #default="scope">
        <div v-for="elem in scope.row.xq7.kclist" :key="elem.id" @click="chuanshujv(elem,jtsjfirm.sj7,1)"
          class="divspanlv">
          <span v-if="elem.sklx==2">{{elem.kcmc}}(拆)</span>
          <span v-if="elem.sklx==1">{{elem.kcmc}}(合)</span>
          <span v-if="elem.sklx==0">{{elem.kcmc}}</span>
          <div>
            <span v-show="elem.kclb==1">理论</span>
            <span v-show="elem.kclb==2">实践</span>
          </div>
          <span>{{elem.jsxms}}</span>
        </div>
      </template>
    </el-table-column>
  </el-table>
</template>

<script setup>
import { ref, defineProps, watch, defineEmits } from 'vue'
import { actionPost } from '@/api/common'
const props = defineProps({
  bilistdata: {
    type: Array,
    required: true
  },
  xqid: {
    type: String,
    required: true
  },
  zcid: {
    type: String,
    required: true
  },
  bjloading: {
    type: Boolean,
    required: true
  }
})
const loading = ref(false)
const zcid = ref('') // 周次
const xqid = ref('') // 学期id
const tableData = ref() // 课表结构
const merge = ref() // 存放需要合并的行
const pos = ref() // 需要合并行下标
const banjilistdata = ref() // 班级课表数据
const emits = defineEmits(['falseloding', 'chuanshujvxl'])
const jtsjfirm = ref({
  sj1: '',
  sj2: '',
  sj3: '',
  sj4: '',
  sj5: '',
  sj6: '',
  sj7: ''
})
// 课表结构
const getkebiaojiegou = () => {
  actionPost({
    url: '/api/v2/jiaowu/jiaowukebiaojiegou/list',
    data: {}
  }).then((res) => {
    res.data.xqRow.forEach((element) => {
      if (banjilistdata.value) {
        banjilistdata.value.forEach((item) => {
          if (item.xq === 1) {
            if (element.xq1.jc === item.jc) {
              element.xq1.kclist = item.kcs
            }
          }
          if (item.xq === 2) {
            if (element.xq2.jc === item.jc) {
              element.xq2.kclist = item.kcs
            }
          }
          if (item.xq === 3) {
            if (element.xq3.jc === item.jc) {
              element.xq3.kclist = item.kcs
            }
          }
          if (item.xq === 4) {
            if (element.xq4.jc === item.jc) {
              element.xq4.kclist = item.kcs
            }
          }
          if (item.xq === 5) {
            if (element.xq5.jc === item.jc) {
              element.xq5.kclist = item.kcs
            }
          }
          if (item.xq === 6) {
            if (element.xq6.jc === item.jc) {
              element.xq6.kclist = item.kcs
            }
          }
          if (item.xq === 7) {
            if (element.xq7.jc === item.jc) {
              element.xq7.kclist = item.kcs
            }
          }
        })
      }
    })

    // bjloading.value = false
    emits('falseloding')
    tableData.value = res.data.xqRow
    //
    xvk(res.data.xqRow)
  })
}
// 传数据
const chuanshujv = (val, time, number) => {
  emits('chuanshujvxl', val, time, number)
}
// 周次具体日期
const getnianyve = () => {
  actionPost({
    url: '/api/v2/jiaowu/jiaowuxiaoli/zhouciriqi',
    data: {
      xqid: xqid.value,
      zc: zcid.value
    }
  }).then((res) => {
    res.data.forEach((sjdata) => {
      if (sjdata.xq === 1) {
        jtsjfirm.value.sj1 = sjdata.rq
      }
      if (sjdata.xq === 2) {
        jtsjfirm.value.sj2 = sjdata.rq
      }
      if (sjdata.xq === 3) {
        jtsjfirm.value.sj3 = sjdata.rq
      }
      if (sjdata.xq === 4) {
        jtsjfirm.value.sj4 = sjdata.rq
      }
      if (sjdata.xq === 5) {
        jtsjfirm.value.sj5 = sjdata.rq
      }
      if (sjdata.xq === 6) {
        jtsjfirm.value.sj6 = sjdata.rq
      }
      if (sjdata.xq === 7) {
        jtsjfirm.value.sj7 = sjdata.rq
      }
    })
    getkebiaojiegou()
  })
}
watch(
  () => props.bjloading,
  () => {
    if (props.bjloading) {
      loading.value = props.bjloading
      //
      getkebiaojiegou()
    }
  },
  { deep: true, immediate: true }
)
watch(
  () => props.bilistdata,
  () => {
    if (props.bilistdata) {
      banjilistdata.value = props.bilistdata
      //
      getkebiaojiegou()
    }
  },
  { deep: true, immediate: true }
)
watch(
  () => props.xqid,
  () => {
    if (props.xqid) {
      xqid.value = props.xqid
      //
      getnianyve()
    }
  },
  { deep: true, immediate: true }
)
watch(
  () => props.zcid,
  () => {
    if (props.zcid) {
      zcid.value = props.zcid
      //
      getnianyve()
    }
  },
  { deep: true, immediate: true }
)
// 分析时段
const xvk = (data) => {
  merge.value = []
  for (let i = 0; i < data.length; i++) {
    if (i === 0) {
      merge.value.push(1)
      pos.value = 0
    } else {
      // 判断当前元素与上一个元素是否相同
      // 根据相同id进行合并,根据需要可进行修改
      if (data[i].sd === data[i - 1].sd) {
        merge.value[pos.value] += 1
        merge.value.push(0)
      } else {
        merge.value.push(1)
        pos.value = i
      }
    }
  }
}
const SpanCellMerge = ({ row, column, rowIndex, columnIndex }) => {
  if (columnIndex === 0) {
    const _row = merge.value[rowIndex]
    const _col = _row > 0 ? 1 : 0
    return {
      rowspan: _row,
      colspan: _col
    }
  }
}
const dSpanCellMerge = ({ row, column, rowIndex, columnIndex }) => {
  if (columnIndex === 0) {
    const _row = merge.value[rowIndex]
    const _col = _row > 0 ? 1 : 0
    return {
      rowspan: _row,
      colspan: _col
    }
  }
}
const sSpanCellMerge = ({ row, column, rowIndex, columnIndex }) => {
  if (columnIndex === 0) {
    const _row = merge.value[rowIndex]
    const _col = _row > 0 ? 1 : 0
    return {
      rowspan: _row,
      colspan: _col
    }
  }
}
getkebiaojiegou()
getnianyve()
</script>
<style scoped lang="less">
  .divspanlv {
    width: 100px;
    display: flex;
    flex-direction: column;
  }
</style>
